import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/EventAvailable';
import edit from './edit';
import list from './list';

const visitSchedules: ResourceProps = {
  name: 'visit-schedules',
  icon,
  options: { label: 'Agendamentos' },
  edit,
  list
};

export const statusChoices = [
  { id: 'WAITING', name: 'Aguardando' },
  { id: 'CONFIRMED', name: 'Confirmado' },
  { id: 'CANCELED', name: 'Cancelado' }
]

export default visitSchedules;